import { FC } from "react";
import { useTranslation } from "react-i18next";

import { MuiAlert } from "@ryde/controls";

export const NeedGroupingReportPanel: FC = () => {
  const { t } = useTranslation();
  return (
    <MuiAlert
      sx={{ marginTop: "20px", marginInlineEnd: "20px" }}
      severity="warning"
    >
      {t("report.CHOOSE_GROUPING_PARAMETER")}
    </MuiAlert>
  );
};
